import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

import { NotificationsService } from '../../core/services/notifications.service';
import { TeacherNotificationResponse } from '../../core/models/notification.model';

export const notificationsRecentResolver: ResolveFn<TeacherNotificationResponse> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(NotificationsService).getRecentNotifications();
};
